import {useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Tabs, Tab} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

import {ActivityFilterType} from '../enums';
import {ActivityFilters} from '../types';

import {DashboardDetailed} from './DashboardDetailed';
import {DashboardTotal} from './DashboardTotal';

const T_KEYS = TRANSLATION_KEYS.USER.ACTIVITY.DASHBOARD;

type Props = {
    filters: ActivityFilters | null;
    isLoading: boolean;
    downloadFileDisabled?: boolean;
    setAvailableFilters: (filters: ActivityFilterType[]) => void;
    onToggleLoading: (value: boolean) => void;
};

export const Dashboard = ({setAvailableFilters, ...rest}: Props) => {
    const {t} = useTranslation();

    const {totalStatistic, detailedView} = useMemo(() =>
        userAuthUtils.getUserPermissions().activity.dashboard, []);

    useEffect(() => {
        setAvailableFilters([
            ActivityFilterType.StartDate,
            ActivityFilterType.EndDate,
            ActivityFilterType.User,
            ActivityFilterType.Group,
            ActivityFilterType.Subgroup,
            ActivityFilterType.Result,
            ActivityFilterType.ResultInformation,
            ActivityFilterType.SessionId,
            ActivityFilterType.FilePipelineStatus,
            ActivityFilterType.ClientDevice,
            ActivityFilterType.UserInfoId
        ]);
    }, [setAvailableFilters]);

    return (
        <Tabs>
            <Tab name={t(T_KEYS.TABS.TOTAL)} hidden={!totalStatistic?.enabled}>
                <DashboardTotal {...rest} />
            </Tab>
            <Tab name={t(T_KEYS.TABS.DETAILED)} hidden={!detailedView?.enabled}>
                <DashboardDetailed {...rest} />
            </Tab>
        </Tabs>
    );
};
